@if (id || localId){
  <div class="holder">
    <div class="screenshot-info-container">
      <div class="info-heading">
        Screenshot Information
      </div>
      @if (localId && !id && name) {
        <div class="info-entry">
          <span class="label">Name:</span>
          <span class="value">{{ name }}</span>
        </div>
      }
      @if (!modifyingName && id) {
        <div class="info-entry">
          <span class="label">Name:</span>
          <span (click)="modifiedName = modifiedName || name || ''; modifyingName = true; $event.stopPropagation();" class="edit-value">{{ name }}</span>
        </div>
      }
      @if (modifyingName && id) {
        <div class="modifying-name">
          <span class="label">Name:</span>
          <input #nameInput (blur)="(!modifiedName || modifiedName === name) && (modifyingName = false);" type="text" pInputText [(ngModel)]="modifiedName">
          <p-button (onClick)="changeName()">Rename</p-button>
        </div>
      }
      @if(metadata?.width){
        <div class="info-entry">
            <span class="label">Width:</span>
            <span class="value">{{ metadata.width}}</span>
        </div>
        }
      @if(metadata?.height){
        <div class="info-entry">
            <span class="label">Height:</span>
            <span class="value">{{metadata.height}}</span>
        </div>
      }
      @if(mimeType){
        <div class="info-entry">
            <span class="label">Format:</span>
            <span class="value">{{mimeType}}</span>
        </div>
      }
    </div>
    <div class="download-container">
      <div class="download-heading">Download Screenshots</div>
      <div class="download">
        @if (localId){
          <input class="input-field" type="text" pInputText placeholder="Name Screenshot for Download" [(ngModel)]="inputName" data-testing-id="workbench-screenshot-name-input" pTooltip="The default name is screenshot"/>
        }
        <div [pTooltip]="isEditingScreenshot? 'Not available while editing' : ''">
          <button pButton type="button" [style]="'width:120px'" [disabled]="isEditingScreenshot" (click)="downloadScreenshot()" data-testing-id="workbench-screenshot-download-btn">Download</button>
        </div>
      </div>
    </div>
    @if (activeTestRun || activeActivity) {
      <div>
        <div class="tool-heading">
          Add Screenshot to Finding
        </div>
        <wm-add-to-finding type="screenshot" [addedToFinding]="addedToFinding" (findingSelected)="addToFinding($event)"></wm-add-to-finding>
      </div>
    }
    <div>
      <div class="tool-heading">
        Screenshot Analysis
      </div>
      <p-button styleClass="p-button" (click)="analyzeContrast()" [loading]="analyzingContrast"  icon="true" [label]="analyzingContrast ? 'Analyzing Contrast' : 'Analyze Contrast'" data-testing-id="workbench-screenshot-contrast-analysis-btn">
        @if (!analyzingContrast) {
          <fa-icon [icon]="faAdjust" [fixedWidth]="true"></fa-icon>
        }
      </p-button>
    </div>
  </div>
} @else {
  <p>No tool available</p>
}
